
import $ from "jquery";
import LazyLoad from "lazyload";


export default class Util {
    static getModuleName () {
        return document.body.getAttribute('module');
    }
    
    static ask( url , msg ){
        if (!confirm(msg)){
            return;
        }
        location.href =url;
    }


    static ISC(d){for(var x in d){var ga=document.createElement('script');ga.type='text/javascript';ga.async=true;ga.src=d[x];var s=document.getElementsByTagName('script')[0];s.parentNode.insertBefore(ga,s)}}

    static scrollBottom(callback){
        window.onscroll = function(){
            //变量scrollTop是滚动条滚动时，距离顶部的距离
            var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
            //变量windowHeight是可视区的高度
            var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
            //变量scrollHeight是滚动条的总高度
            var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
            //滚动条到底部的条件
            if( scrollTop+windowHeight == scrollHeight ){
                console.log("距顶部"+scrollTop+"可视区高度"+windowHeight+"滚动条总高度"+scrollHeight);
                callback();
            }
        }
    }

    static isSupWebP() {
        try{
            return document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') == 0;
        } catch (e){
            return false;
        }
    }

    static handleWebp(){
        if ( window.useWebp === true ){
            window.isSupWebp = this.isSupWebP();
            if (isSupWebp){
                $('img.dwebp').each(function(){
                    var src = $(this).attr('data-src') || $(this).attr('src');
                    $(this).attr("data-src",src + ".webp");
                });
            }
        }
        let images = document.querySelectorAll("img[data-src]");
        new LazyLoad(images);
    }

    /**
     * qs 包在Android低版本会报错
     * @param arrObj
     */
    static buildQuery( arrObj ){
        let ret = [];
        for(var x in arrObj){
            ret.push(x + "=" + encodeURIComponent(arrObj[x]));
        }
        return ret.join('&');
    }

    static makeSearchUrl(){

    }

    /**
     *
     <div class="g-loading">
     <div class="spinner-border text-light" role="status">
     <span class="sr-only"></span>
     </div>
     </div>
     */
    static loading(type){
        if ( $('.g-loading').length == 0 ){
            $('body').append(`
                <div class="g-loading">
    <div class="spinner-border " role="status">
     <span class="sr-only"></span>
     </div>
     </div>
            `);
        }
        if ( type == 'hide'){
            $('.g-loading').hide();
        } else {
            $('.g-loading').show();
        }

    }

    static formLoading( type ){
        if ( type == 'hide' ){
            $('.js-submit').removeAttr('disabled');
            $('.js-submit span').hide();
            return;
        }

        if ( typeof type == 'undefined' || type == 'show'){
            $('.js-submit').attr('disabled','disabled');
            $('.js-submit span').show();
            return;
        }
    }


    static alert(msg , title){
        if ( typeof title == 'undefined'){
            title = LANG.globalMessageTitle;
        }
            var tpl = `<div class="modal fade" id="globalModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">${title}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                ${msg}
            </div>
        </div>
    </div>
</div>`;
        if ( $('#globalModal-cont').length == 0 ){
            $('body').append(`
                <div id="globalModal-cont">${tpl}</div>
            `);
        } else {
            $('#globalModal-cont').html(tpl);
        }
        $('#globalModal').modal('show');
    }

    static goPost(cfg){
        if (cfg.length == 1){
            location.href = cfg[0].url;return;
        }
        var list = [];
        for(var x in cfg){
            list.push(`<a href="${cfg[x].url}" class="list-group-item"><i class="${cfg[x].css}"></i>${cfg[x].desc}</a>`);
        }

        this.alert(`<div class="card post-select">
            <div class="card-header">
            </div>
            <ul class="list-group list-group-flush">
            `+list.join('')+`
            </ul>
        </div>`);
    }
}



// WEBPACK FOOTER //
// ./src/lib/util.js